import React from 'react';
import classNames from 'classnames';
import styles from './TextEditor.module.scss';
import Loader, { LoaderType } from '../Loader/Loader';
import AIInput from '../AIInput/AIInput';
import GeneratedContent from '../GeneratedContent/GeneratedContent';

interface Props {
  text: string;
  isTextGenerating: boolean;
  isPremium: boolean;
  subjectGroup?: string;
  onAiInputSubmit?: (value: string) => void;
}

const TextEditor: React.FC<Props> = ({
  isTextGenerating,
  isPremium,
  text,
  subjectGroup,
  onAiInputSubmit,
}) => {
  // Preprocess the text to replace \( ... \) with $ ... $ for inline math
  // and \[ ... \] with $$ ... $$ for block math
  const processedText = text
    .replace(/\\\(/g, '$') // Replace opening \( with $
    .replace(/\\\)/g, '$') // Replace closing \) with $
    .replace(/\\\[/g, '$$') // Replace opening \[ with $$
    .replace(/\\\]/g, '$$'); // Replace closing \] with $$

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.notPremium]: !isPremium,
      })}>
      {isTextGenerating && !processedText ? (
        <Loader type={LoaderType.EDITOR} />
      ) : (
        <div className={styles.textEditor}>
          <GeneratedContent
            text={processedText}
            isTextGenerating={isTextGenerating}
          />

          {onAiInputSubmit && !isTextGenerating && (
            <AIInput
              onSubmit={onAiInputSubmit}
              disabled={isTextGenerating}
              subjectGroup={subjectGroup}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default TextEditor;
